/**
 * Bytes as the relay sends and reads them (part 36a; the relay's `auth/bytes.ts`): base64url without padding, read
 * strictly, so one value has one spelling and a stray character or unused trailing bits never pass (principle C4).
 */

const BASE64URL = /^[A-Za-z0-9_-]*$/u;

/** Bytes as base64url without padding. */
export function toBase64Url(bytes: Uint8Array): string {
  let binary = '';
  for (const byte of bytes) binary += String.fromCharCode(byte);
  return btoa(binary).replace(/\+/gu, '-').replace(/\//gu, '_').replace(/=+$/u, '');
}

/** Reads base64url without padding, strictly: only the alphabet and only the spelling {@link toBase64Url} writes; null otherwise. */
export function fromBase64Url(text: string): Uint8Array<ArrayBuffer> | null {
  if (!BASE64URL.test(text) || text.length % 4 === 1) return null;
  const binary = atob(text.replace(/-/gu, '+').replace(/_/gu, '/'));
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
  return toBase64Url(bytes) === text ? bytes : null;
}

/** Base64url bytes of exactly `length`, or null. */
export function bytesOfLength(value: unknown, length: number): Uint8Array<ArrayBuffer> | null {
  const bytes = typeof value === 'string' ? fromBase64Url(value) : null;
  return bytes?.length === length ? bytes : null;
}

/** Text as UTF-8 bytes. */
export function utf8(text: string): Uint8Array<ArrayBuffer> {
  return new TextEncoder().encode(text);
}
